import { GENERAL_CONSTS } from "../constants";

export const initialState = {
    languages: [],
    selectedLanguage: null,
    staticTexts: {},
    sliderHome:[],
    sliderBanner:[],
    countryCode: 'hy',
    isOpen:undefined,
    contacts: {},
    about: {},
    advertisement: [],
};

export default (state = initialState, action) => {
    switch ( action.type ) {
        case GENERAL_CONSTS.GET_LANGUAGES:
            const languages = action.payload.languages
            const countryCode = action.payload.countryCode
            const enLanguage = languages.find(lg => lg.code === 'hy');
            const selectedLanguage = state.selectedLanguage && state.selectedLanguage.id
                && languages.find(lg => lg.code === state.selectedLanguage.code);

            const countryLanguage = languages.find(lg => lg.code === countryCode);

            const newSelectedLanguage = selectedLanguage ? selectedLanguage :
                (countryLanguage ? countryLanguage : (enLanguage ? enLanguage : languages[0]));

            const newState = {
                ...state,
                languages,
                selectedLanguage: newSelectedLanguage,
            };

            if (state.staticTexts && state.staticTexts[newSelectedLanguage.code]) {
                newState.staticTexts = state.staticTexts[newSelectedLanguage.code]
            }

            return newState;
        case GENERAL_CONSTS.CHANGE_LANGUAGE:
            return {
                ...state,
                selectedLanguage: action.payload,
            };
        case GENERAL_CONSTS.GET_STATIC_TEXTS:
            return {
                ...state,
                staticTexts: action.payload[state.selectedLanguage?.code || 'hy']
            };
        case GENERAL_CONSTS.GET_SLIDER_HOME:
            return {
                ...state,
                sliderHome:action.payload
            };
        case GENERAL_CONSTS.GET_SLIDER_BANNER:
            return {
                ...state,
                sliderBanner:action.payload
            };
        case GENERAL_CONSTS.IS_OPEN:
            return {
                ...state,
                isOpen: action?.payload
            }
        case GENERAL_CONSTS.GET_CONTACTS:
            return {
                ...state,
                contacts: action.payload
            };
        case GENERAL_CONSTS.GET_ABOUT:
            return {
                ...state,
                about: action.payload
            };
        case GENERAL_CONSTS.GET_ADVERTISEMENT:
            return {
                ...state,
                advertisement: action.payload
            };
        default:
            return state;
    }
}
